import { Stack, tokens } from '@hotjar/hotsauce';
import type { ReactNode } from 'react';
import { useCallback, useState } from 'react';
import { SidebarCategoryButton } from './SidebarCategoryButton';

export interface SidebarCategoryProps {
  title: string;
  children: ReactNode;
  categoryId: string;
  hideDivider?: boolean;
  className?: string;
}

export const SidebarCategory = ({
  title,
  children,
  categoryId,
  hideDivider,
  className,
}: SidebarCategoryProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleClick = useCallback(() => {
    setIsExpanded((wasExpanded) => !wasExpanded);
  }, []);

  return (
    <Stack style={{ width: '100%' }} direction="column">
      <SidebarCategoryButton
        hideDivider={hideDivider}
        title={title}
        categoryId={categoryId}
        isExpanded={isExpanded}
        onClick={handleClick}
      />

      {isExpanded && (
        <Stack
          id={categoryId}
          style={{ paddingLeft: tokens.spacer.x1 }}
          direction="column"
          spacing="x0pt5"
          className={className}
        >
          {children}
        </Stack>
      )}
    </Stack>
  );
};
